import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
//Job Links
import JobSearchData from './components/JobSearch';
import JobDetailData from './components/JobDetails';
import JobQuoteData from './components/JobQuote';
import JobQuoteHistoryData from './components/JobQuoteHistory';
import JobScheduleData from './components/JobSchedule';
import JobPhotosData from './components/JobPhotos';
import JobFilesData from './components/JobFiles';
import JobInvoiceData from './components/JobInvoices';
import JobNoteData from './components/JobNotes';
import JobReportViewerData from './components/JobReportViewer';
import NewJobData from './components/NewJob';

//schedule screens
import ScheduleNewData from './components/ScheduleNew';
import ScheduleDayMapData from './components/ScheduleDayMap';
import ScheduleEventData from './components/ScheduleEvent';
import ScheduleTiltCraneData from './components/ScheduleTiltCrane';
import SchedulePickupData from './components/SchedulePickup';
import AllocateMapData from './components/AllocateMap';
import AllocateMapDunnyData from './components/AllocateMapDunny';
import AllocateData from './components/AllocateScreen';
import RunSheetData from './components/RunSheet';
import RunSheetDriverUpdateData from './components/RunSheetDriverUpdate';

//Reports
import ReportListData from './components/Reports'
import ReportItemsOnHireByDateData from './components/ReportItemsOnHireByDate';
import ReportJobQuoteSummaryData from './components/ReportJobQuoteSummary';
import ReportCamerasOnHireData from './components/ReportCamerasOnHire';
import ReportConditionData from './components/ReportCondition';
import ReportCustomerEmailsData from './components/ReportCustomerEmails';
import ReportCustomerGateCodesData from './components/ReportCustomerGateCodes';
import ReportCustomersLockedData from './components/ReportCustomersLocked';
import ReportDeletedJobsData from './components/ReportDeletedJobs';
import ReportEventJobSummaryData from './components/ReportEventJobSummary';
import ReportFencingPickedUpData from './components/ReportFencingPickedUp';
import ReportInvoicesSentToReckonData from './components/ReportInvoicesSentToReckon';
import ReportItemsOnHireData from './components/ReportItemsOnHire';
import ReportItemsOnHireSummaryData from './components/ReportItemsOnHireSummary';
import ReportJobChecksData from './components/ReportJobChecks';
import ReportJobKpisData from './components/ReportJobKpis';
import ReportJobQuoteData from './components/ReportJobQuote';
import ReportJobsAwaitingPaymentData from './components/ReportJobsAwaitingPayment';
import ReportPowerPolesOnHireData from './components/ReportPowerPolesOnHire';
import ReportPowerPolesScheduledData from './components/ReportPowerPolesScheduled';
import ReportPrepaidHireEndingData from './components/ReportPrepaidHireEnding';
import ReportSalesByBranchAndProductGroupSummaryData from './components/ReportSalesByBranchAndProductGroupSummary';
import ReportSalesByBranchSummaryData from './components/ReportSalesByBranchSummary';
import ReportSalesByProductData from './components/ReportSalesByProduct';
import ReportJobSummaryByProductGroupData from './components/ReportJobSummaryByProductGroup';
import ReportTruckChecksData from './components/ReportTruckChecks';
import ReportTruckChecksGroupedData from './components/ReportTruckChecksGrouped';
import ReportCustomerPricelistData from './components/ReportCustomerPricelist';
import ReportPrepaidInvoicesSentData from './components/ReportPrepaidInvoicesSent';
import ReportViewerData from './components/ReportViewer'

//Customers
import CustomerSearchData from './components/CustomerSearch';
import CustomerData from './components/Customer';
import CustomerAddData from './components/CustomerAdd';

//Invoicing 
import SendInvoicesData from './components/InvoicesToSend';
import InvoiceBatchData from './components/InvoiceBatch';
import InvoiceCreditData from './components/InvoiceCredits';
import InvoiceSearchData from './components/InvoiceSearch';
import InvoiceAddData from './components/InvoiceAdd';

//Admin Lists
import AdminListData from './components/AdminLists';
import AdminPriceListEpaData from './components/AdminPriceListEpa';
import AdminPriceListPumpAndCleanData from './components/AdminPriceListPumpAndClean';
import AdminPriceListFencingCustomData from './components/AdminPriceListsFencingCustom';
import AdminPriceListFencingData from './components/AdminPriceListsFencing';
import AdminPriceListEventData from './components/AdminPriceListEvent';
import AdminPriceListCustomData from './components/AdminPriceListCustom';
import AdminPriceListKwikstageData from './components/AdminPriceListsKwikstage';
import AdminPriceListTowerData from './components/AdminPriceListsTower';
import AdminPriceListPowerPoleConnectionData from './components/AdminPriceListPowerPoleConnection';
import AdminPriceListSettingsData from './components/AdminPriceListsSettings';
import AdminTrucksData from './components/AdminTrucks';
import AdminReckonData from './components/AdminReckonData';
import AdminSystemFilesData from './components/AdminSystemFiles';
import AdminSurchargeData from './components/AdminSurcharge';
import AdminPriceListData from './components/AdminPriceLists';
import AdminPriceListSetWeeksData from './components/AdminPriceListSetWeeks';
import PublicHolidayData from './components/AdminPublicHolidays';
import ShutdownPeriodData from './components/AdminShutdownPeriods';
import ItemFormulaData from './components/AdminItemFormulas';
import ItemPhotoData from './components/AdminItemPhoto';

//User
import UserSearchData from './components/UserSearch';
import UserData from './components/User';

//Other
import PermissionFailed from './components/PermissionFailed';
import ReckonRedirectData from './components/ReckonRedirect';
import JobsRequiringPaymentData from './components/JobsRequiringPayment';
import ItemTaskData from './components/ItemTasks';

//Driver Jobs
import DriverJobsData from './components/DriverJobs';
import DriverJobsTomorrowData from './components/DriverJobsTomorrow';
import DriverJobsTeamData from './components/DriverJobsTeam';
import TruckChecklistData from './components/TruckCheck';
import TruckToolChecklistData from './components/TruckToolCheck';
import ReportCsrSalesSummaryData from './components/ReportCsrSalesSummary';
import ReportEpaJobsData from './components/ReportEpaJobs';

function DashRoutes() {

    return (
        <div className="main-container">
            <div id="screen-container" className="screen-container">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/jobsearch" element={<JobSearchData />} />
                    <Route path="/job/:id/details" element={<JobDetailData />} />
                    <Route path="/job/:id/quote" element={<JobQuoteData />} />
                    <Route path="/job/:id/quotehistory" element={<JobQuoteHistoryData />} />
                    <Route path="/job/:id/schedule" element={<JobScheduleData /> } />
                    <Route path="/job/:id/photos" element={<JobPhotosData /> } />
                    <Route path="/job/:id/files" element={<JobFilesData />} />
                    <Route path="/job/:id/invoices" element={<JobInvoiceData /> } />
                    <Route path="/job/:id/notes" element={<JobNoteData />} />
                    <Route path='/job/:id/report/:name/:param1?' element={<JobReportViewerData />} />
                    <Route path='/newjob/:typeId/:copyId?' element={<NewJobData /> } />

                    <Route path='/schedulenew/map/:scheduleBranchId/:scheduleDate' element={<ScheduleDayMapData />} />
                    <Route path='/schedulenew' element={<ScheduleNewData />} />
                    <Route path='/scheduleevent' element={<ScheduleEventData />} />
                    <Route path='/scheduletiltcrane' element={<ScheduleTiltCraneData /> } />
                    <Route path='/schedulepickup' element={<SchedulePickupData /> } />

                    <Route path='/allocate/map/:scheduleDate' element={<AllocateMapData />} />
                    <Route path='/allocate/googlemap/:scheduleDate/:scheduleBranchId/:itemTypeGroupId' element={<AllocateMapDunnyData />} />
                    <Route path='/allocate' element={< AllocateData />} />

                    <Route path='/runsheet' element={< RunSheetData />} />
                    <Route path='/runsheetdriver' element={<RunSheetDriverUpdateData /> } />

                    <Route path='/itemtasks' element={<ItemTaskData /> } />
                    <Route path='/jobsrequiringpayment' element={<JobsRequiringPaymentData /> } />

                    <Route path='/report/:name/:param1/:param2/:param3/:param4/:param5' element={<ReportViewerData />} />
                    <Route path='/reports/jobkpis' element={<ReportJobKpisData />} />
                    <Route path='/reports/itemsonhiresummary' element={<ReportItemsOnHireSummaryData />} />
                    <Route path="/reports/itemsonhirebydate" element={<ReportItemsOnHireByDateData />} />
                    <Route path='/reports/itemsonhire' element={<ReportItemsOnHireData />} />
                    <Route path='/reports/prepaidhireending' element={<ReportPrepaidHireEndingData />} />
                    <Route path='/reports/prepaidinvoicessent' element={<ReportPrepaidInvoicesSentData />} />
                    <Route path='/reports/jobquote' element={<ReportJobQuoteData />} />
                    <Route path='/reports/deletedjobs' element={<ReportDeletedJobsData />} />
                    <Route path='/reports/csrsalessummary' element={<ReportCsrSalesSummaryData />} />
                    <Route path='/reports/salesbyproduct' element={<ReportSalesByProductData />} />
                    <Route path='/reports/salesbybranchsummary' element={<ReportSalesByBranchSummaryData />} />
                    <Route path='/reports/salesbybranchandproductgroupsummary' element={<ReportSalesByBranchAndProductGroupSummaryData />} />
                    <Route path='/reports/jobsummarybyproductgroup' element={<ReportJobSummaryByProductGroupData /> } />
                    <Route path='/reports/epajobs' element={<ReportEpaJobsData /> } />
                    <Route path='/reports/truckchecksgrouped' element={<ReportTruckChecksGroupedData />} />
                    <Route path='/reports/truckchecks' element={<ReportTruckChecksData />} />
                    <Route path='/reports/jobchecks' element={<ReportJobChecksData />} />
                    <Route path="/reports/jobquotesummary" element={<ReportJobQuoteSummaryData />} />
                    <Route path='/reports/customeremails' element={<ReportCustomerEmailsData />} />
                    <Route path='/reports/customergatecodes' element={<ReportCustomerGateCodesData />} />
                    <Route path='/reports/camerasonhire' element={<ReportCamerasOnHireData />} />
                    <Route path='/reports/powerpolesscheduled' element={<ReportPowerPolesScheduledData />} />
                    <Route path='/reports/condition' element={<ReportConditionData />} />
                    <Route path='/reports/customerslocked' element={<ReportCustomersLockedData />} />
                    <Route path='/reports/jobsawaitingpayment' element={<ReportJobsAwaitingPaymentData />} />
                    <Route path='/reports/invoicessenttoreckon' element={<ReportInvoicesSentToReckonData />} />
                    <Route path='/reports/powerpolesonhire' element={<ReportPowerPolesOnHireData />} />
                    <Route path='/reports/fencingpickedup' element={<ReportFencingPickedUpData />} />
                    <Route path='/reports/eventjobsummary' element={<ReportEventJobSummaryData />} />
                    <Route path='/reports/customerspricelist' element={<ReportCustomerPricelistData />} />
                    <Route path="/reports" element={<ReportListData />} />

                    <Route path="/customersearch" element={<CustomerSearchData /> } />
                    <Route path='/customer/:id?' element={<CustomerData />} />
                    <Route path='/customeradd' element={<CustomerAddData /> } />

                    <Route path='/sendinvoices' element={<SendInvoicesData />} />
                    <Route path='/invoicebatch' element={<InvoiceBatchData /> } />
                    <Route path='/invoicecredit' element={<InvoiceCreditData />} />
                    <Route path='/invoices' element={<InvoiceSearchData />} />
                    <Route path='/invoiceadd' element={<InvoiceAddData />} />

                    <Route path='/adminlists' element={<AdminListData /> } />
                    <Route path='/pricelists' element={<AdminPriceListData />} />
                    <Route path='/pricelistsetweeks' element={<AdminPriceListSetWeeksData />} />
                    <Route path='/pricelistepa' element={<AdminPriceListEpaData />} />
                    <Route path='/pricelistpumpclean' element={<AdminPriceListPumpAndCleanData />} />
                    <Route path='/pricelistfencingcustom' element={<AdminPriceListFencingCustomData />} />
                    <Route path='/pricelistfencing' element={<AdminPriceListFencingData />} />
                    <Route path='/pricelistevent' element={<AdminPriceListEventData />} />
                    <Route path='/pricelistcustom' element={<AdminPriceListCustomData />} />
                    <Route path='/pricelistkwikstage' element={<AdminPriceListKwikstageData />} />
                    <Route path='/pricelisttowers' element={<AdminPriceListTowerData />} />
                    <Route path='/pricelistpowerpoleconnection' element={<AdminPriceListPowerPoleConnectionData />} />
                    <Route path='/pricelistsettings' element={<AdminPriceListSettingsData />} />
                    <Route path='/publicholidays' element={<PublicHolidayData />} />
                    <Route path='/shutdownperiods' element={<ShutdownPeriodData />} />
                    <Route path='/itemformulas' element={<ItemFormulaData />} />
                    <Route path='/itemphoto' element={<ItemPhotoData />} />
                    <Route path='/trucks' element={<AdminTrucksData />} />
                    <Route path='/reckondata' element={<AdminReckonData />} />
                    <Route path='/systemfiles' element={<AdminSystemFilesData />} />
                    <Route path='/surcharges' element={<AdminSurchargeData />} />

                    <Route path='/driverjobs' element={<DriverJobsData />} />
                    <Route path='/drivertomorrowjobs/:truckId' element={<DriverJobsTomorrowData />} />
                    <Route path='/drivertruckcheck/:truckId' element={<TruckChecklistData />} /> 
                    <Route path='/drivertoolcheck/:truckId/:timeOfDay' element={<TruckToolChecklistData /> } />
                    <Route path='/driverteam/:truckId' element={<DriverJobsTeamData /> } />

                    <Route path='/usersearch' element={<UserSearchData />} />
                    <Route path='/user/:id' element={< UserData />} />

                    <Route path="./reckonredirect" element={<ReckonRedirectData /> } />
                    
                    <Route path="/accessdenied" element={<PermissionFailed /> } />
                    {/* Handle unmatched routes (e.g., a 404 page) */}
                    <Route path="*" element={<h1>Page Not Found</h1>} />
                </Routes>
            </div>
        </div>
    );

}

export default DashRoutes;